import { Icon, IconProps } from '@chakra-ui/react';
import * as React from 'react';

export const VoicemailIcon: React.FC<IconProps> = (props) => (
  <Icon
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <circle cx="5.5" cy="11.5" r="4.5"></circle>
    <circle cx="18.5" cy="11.5" r="4.5"></circle>
    <line x1="5.5" y1="16" x2="18.5" y2="16"></line>
  </Icon>
);
